// extracted by mini-css-extract-plugin
module.exports = {"defaultLayout":"_4N1lpE-sRo9_8CvtdQttW"};